/**
 * Shared motion values for Motion (`motion/react`) transitions and WAAPI options.
 * EASE_OUT: strong ease-out for anything entering or leaving (starts fast, feels responsive).
 */
export const EASE_OUT = [0.23, 1, 0.32, 1] as const

/** Default duration (seconds) for UI enter/exit, e.g. a list row or a small panel. */
export const DURATION_UI = 0.2
